import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IDeleteBusinessUserPayload,
  ActionType,
  DeleteBusinessUserResponse,
} from "models/userListBusiness/deleteBusinessUser";
import { httpStatus } from "configs/httpStatus";
import { deleteBusinessUser } from "services/userListBusiness";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./deleteBusinessUserActions";

function* deleteBusinessUserSaga({
  payload,
}: {
  payload: IDeleteBusinessUserPayload;
}) {
  try {
    const response: DeleteBusinessUserResponse = yield call(
      deleteBusinessUser,
      payload
    );
    if (
      response.status === httpStatus.StatusOK ||
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusUnprocessableEntity
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDeleteBusinessUserWatcher() {
  yield takeLatest(
    ActionType.DELETE_BUSINESS_USER as any,
    deleteBusinessUserSaga
  );
}

export default [fork(onDeleteBusinessUserWatcher)];
